import React, { ComponentProps } from 'react';

import Typography from '@setproduct-ui/core/Typography';

export const H4 = ({ colorStep = '', children, ...rest }: ComponentProps<typeof Typography>) => (
  <Typography colorStep={colorStep} type="h4" tagName="h4" {...rest}>
    {children}
  </Typography>
);
